import { z } from 'zod';

export const scaleOptionSchema = z.object({
  label: z.string().min(1, 'Option label is required').max(255, 'Label must be less than 255 characters'),
  value: z.number().int('Value must be an integer'),
});

export const createScaleSchema = z.object({
  code: z.string().min(1, 'Code is required').max(255, 'Code must be less than 255 characters'),
  label: z.string().min(1, 'Label is required').max(255, 'Label must be less than 255 characters'),
  options: z
    .array(scaleOptionSchema)
    .min(2, 'At least 2 options are required')
    .refine(
      (options) => {
        const values = options.map((opt) => opt.value);
        return new Set(values).size === values.length;
      },
      { message: 'All option values must be unique' },
    ),
});

export type CreateScalePayload = z.infer<typeof createScaleSchema>;
